module.exports = __webpack_public_path__ + "static/img/5.aa51612.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue12/5.jpg
// module id = 1ojn
// module chunks = 7